import { render, staticRenderFns } from "./SeminarEdit.vue?vue&type=template&id=2d50a480&"
import script from "./SeminarEdit.js?vue&type=script&lang=js&"
export * from "./SeminarEdit.js?vue&type=script&lang=js&"
import style0 from "./SeminarEdit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports